// extracted by mini-css-extract-plugin
module.exports =  {"avatars":"_02712f2b3b--avatars--_MZr4","primary":"_02712f2b3b--primary--Iw0n2","secondary":"_02712f2b3b--secondary--LCZvi"};